import React from "react";
import { useQuery } from "@tanstack/react-query";
import { MapPin, Clock } from "lucide-react";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function FindUs() {
  const { data: stores = [] } = useQuery({ queryKey: ["stores"], queryFn: async () => (await api.get("/stores")).data });

  return (
    <div className="mx-auto max-w-[1600px] px-5 py-12 md:px-8" data-testid="find-us-page">
      <Seo title="Find Us — The Hoodie Project®" description="Find The Hoodie Project in stockists near you." />
      <div className="mb-10 border-b border-border pb-6">
        <p className="text-xs tracking-[0.3em] text-muted-foreground">STOCKISTS</p>
        <h1 className="mt-3 font-display text-5xl font-extrabold tracking-tighter md:text-7xl">FIND US</h1>
        <p className="mt-4 max-w-lg text-sm text-muted-foreground">We're in select streetwear stores across the country. Come through, touch the fabric, cop a hoodie in person.</p>
      </div>

      {stores.length === 0 ? (
        <p className="text-muted-foreground" data-testid="stores-empty">No stockists listed yet. Check back soon.</p>
      ) : (
        <div className="grid grid-cols-1 border-l border-t border-border md:grid-cols-2 lg:grid-cols-3">
          {stores.map((s) => (
            <div key={s.id} className="border-b border-r border-border p-8" data-testid={`store-${s.id}`}>
              <h3 className="font-display text-2xl font-bold tracking-tight">{s.name}</h3>
              <p className="mt-4 flex items-start gap-2 text-sm text-muted-foreground"><MapPin className="mt-0.5 h-4 w-4 shrink-0" /> {s.address}, {s.city}{s.state ? `, ${s.state}` : ""}</p>
              {s.hours && <p className="mt-2 flex items-start gap-2 text-sm text-muted-foreground"><Clock className="mt-0.5 h-4 w-4 shrink-0" /> {s.hours}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
